import { isEmpty } from "lodash";

export const filterSpaces = (spaces = [], filters = {}) => {
  if (isEmpty(filters)) return spaces;
  return spaces.filter((space) =>
    Object.entries(filters).every(([key, value]) => space[key] === value)
  );
};
